import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const HeliosTheme = createTheme({
  palette: {
    common: {
      black: "#272727"
    },
    primary: {
      main: "#117a65",
      light: "#4daa93",
      dark: "#004d3b"
    },
    secondary: {
      main: "#44b29c",
      light: "#79e5cd",
      dark: "#00826e"
    },
    surface: {
      main: "#ffffffff",
    }
  },
});
export default HeliosTheme;